import { BOOKINGS_TABS } from '../Bookings';
import { dateToState } from "../../../Helpers/DateTimeHelper";
import { globalErrorCondition } from "../../../Helpers/ErrorHelper";
import { sortObjectByField } from "../../../Helpers/ObjectHelper";
import { LOADING } from "../../../Components/Table/TimelineTable";
import { removeElapsedBookings } from "../Common/BookingsCommon";

export const initialState = {
    bookings: {},
    bookingCounts: {},
    dataLoadCount: 0,
    lastUpdated: null,
    recordsAreLoading: false,
    hasMoreRecordsAtEnd: true,
    hasMoreRecordsAtStart: true,
};

// Bookings list actions
export const BOOKINGS_LOADED = 'bookings/list/BOOKINGS_LOADED';
export const BOOKINGS_UPDATE_BOOKING = 'bookings/list/BOOKINGS_UPDATE_BOOKING';
export const BOOKINGSLIST_BOOKING_CANCELLED = 'bookings/list/BOOKINGSLIST_BOOKING_CANCELLED';
export const BOOKINGSLIST_BOOKING_SERIES_CANCELLED = 'bookinhs/list/BOOKINGSLIST_BOOKING_SERIES_CANCELLED';
export const BOOKINGSLIST_BOOKINGS_REMOVED = 'bookings/list/BOOKINGSLIST_BOOKING_REMOVED';
export const BOOKINGSLIST_ELAPSED_BOOKINGS_REMOVED = 'bookings/list/BOOKINGSLIST_ELAPSED_BOOKINGS_REMOVED';
export const SET_RECORDS_ARE_LOADING = 'bookings/list/SET_RECORDS_ARE_LOADING';
export const BOOKINGSLIST_COUNTS_LOADED = 'bookings/list/BOOKINGSLIST_COUNTS_LOADED';

export const setRecordsAreLoading = (view, scope, loadingType) => ({
    type: `${view}_${scope}_${SET_RECORDS_ARE_LOADING}`,
    payload: {
        recordsAreLoading: loadingType,
    }
});

export const bookingsLoaded = (view, scope, data, direction, filterSettingsChanged = false, minRecordsExpected = 20, updateType = LOADING.AT_END) => ({
    type: `${view}_${scope}_${BOOKINGS_LOADED}`,
    payload: {
        scope,
        data,
        direction,
        filterSettingsChanged,
        minRecordsExpected,
        updateType
    }
});

export const bookingListUpdated = (view, scope, booking) => ({
    type: `${view}_${scope}_${BOOKINGS_UPDATE_BOOKING}`,
    payload: booking,
});

export const bookingListRemoveBookings = (view, scope, bookingIds) => ({
    type: `${view}_${scope}_${BOOKINGSLIST_BOOKINGS_REMOVED}`,
    payload: { bookingIds }
});

export const bookingListBookingCancelled = (view, scope, cancelledBooking) => ({
    type: `${view}_${scope}_${BOOKINGSLIST_BOOKING_CANCELLED}`,
    payload: {
        booking: cancelledBooking
    }
})

export const bookingListBookingSeriesCancelled = (view, scope, cancelledBookings) => ({
    type: `${view}_${scope}_${BOOKINGSLIST_BOOKING_SERIES_CANCELLED}`,
    payload: {
        bookings: cancelledBookings
    }
})


export const elapsedBookingsRemoved = (view, scope) => ({
    type: `${view}_${scope}_${BOOKINGSLIST_ELAPSED_BOOKINGS_REMOVED}`,
})

export const bookingCountsLoaded = (view, scope, bookingCounts) => ({
    type: `${view}_${scope}_${BOOKINGSLIST_COUNTS_LOADED}`,
    payload: {
        bookingCounts
    }
})

export const bookingListReducerFor = (view, scope) => {
    return (state = initialState, action) => {
        switch (action.type) {
            case `${view}_${scope}_${SET_RECORDS_ARE_LOADING}`: {
                return {
                    ...state,
                    recordsAreLoading: action.payload.recordsAreLoading,
                }
            }

            case `${view}_${scope}_${BOOKINGS_LOADED}`: {
                let { data, direction, filterSettingsChanged, minRecordsExpected, updateType } = action.payload;

                let newBookings = {};

                if (filterSettingsChanged) {
                    newBookings = {...data.data};
                } else if (scope === BOOKINGS_TABS.UPCOMING) {
                    newBookings = {...state.bookings, ...data.data};
                    newBookings = sortObjectByField(newBookings, 'start', false);

                } else if (scope === BOOKINGS_TABS.PAST) {
                    newBookings = {...state.bookings, ...data.data};
                    newBookings = sortObjectByField(newBookings, 'start', true);

                } else {
                    globalErrorCondition('Unknown scope when loading bookings data', scope);
                }

                // Check if we have any more records for this query type
                let hasMoreRecordsAtEnd = state.hasMoreRecordsAtEnd;
                let hasMoreRecordsAtStart = state.hasMoreRecordsAtStart;

                if (updateType === LOADING.AT_START) {
                    hasMoreRecordsAtStart = !(Object.keys(data.data).length < minRecordsExpected);
                } else {
                    hasMoreRecordsAtEnd = !(Object.keys(data.data).length < minRecordsExpected);
                }

                return {
                    ...state,
                    bookings: {...newBookings},
                    hasMoreRecordsAtEnd: hasMoreRecordsAtEnd,
                    hasMoreRecordsAtStart: hasMoreRecordsAtStart,
                    lastUpdated: dateToState(new Date()),
                    dataLoadCount: state.dataLoadCount + 1,
                    recordsAreLoading: false,
                };
            }

            case `${view}_${scope}_${BOOKINGSLIST_COUNTS_LOADED}`: {
                return {
                    ...state,
                    bookingCounts: {...action.payload.bookingCounts }
                }
            }

            case `${view}_${scope}_${BOOKINGS_UPDATE_BOOKING}`: {
                return {
                    ...state,
                    bookings: {
                        ...state.bookings,
                        [action.payload.id]: action.payload
                    }
                }
            }

            case `${view}_${scope}_${BOOKINGSLIST_BOOKING_CANCELLED}`: {
                return {
                    ...state,
                    bookings: {
                        ...state.bookings,
                        [action.payload.booking.id]: action.payload.booking
                    }
                }
            }

            case `${view}_${scope}_${BOOKINGSLIST_BOOKING_SERIES_CANCELLED}`: {
                return {
                    ...state,
                    bookings: {
                        ...state.bookings,
                        ...action.payload.bookings
                    }
                }
            }

            case `${view}_${scope}_${BOOKINGSLIST_BOOKINGS_REMOVED}`: {
                let newBookings = {...state.bookings};

                for (let bookingId of action.payload.bookingIds) {
                    delete newBookings[bookingId];
                }

                return {
                    ...state,
                    bookings: newBookings,
                }
            }

            case `${view}_${scope}_${BOOKINGSLIST_ELAPSED_BOOKINGS_REMOVED}`:
                return {
                    ...state,
                    bookings: removeElapsedBookings(state.bookings)
                }

            default:
                return state;
        }
    }
};
